<form
  [formGroup]="filtersForm"
  class="d-flex flex-wrap gap-5"
>
  <base-filter-dropdown
    [items]="baseOfferStatusOption"
    filterName="state"
    optionClass="class"
    formControlName="status"
    [multiple]="false"
  >
  </base-filter-dropdown>
  <base-filter-dropdown
    [items]="baseCustomerWCApprovalOptions"
    filterName="workCouncil.label"
    optionClass="class"
    formControlName="workCouncilStatus"
    [multiple]="false"
  >
  </base-filter-dropdown>

  <base-filter-dropdown
    [items]="qualifications"
    filterName="qualifications.plural"
    formControlName="mainQualifications"
    [searchable]="true"
  >
  </base-filter-dropdown>

  <base-filter-dropdown
    [items]="branches"
    [searchable]="true"
    formControlName="pspBranches"
    filterName="provider"
  >
  </base-filter-dropdown>

  <base-filter-dropdown
    [items]="[5, 4, 3, 2, 1]"
    filterName="review"
    bindOptionLabel="value"
    formControlName="rating"
    class="rating-filter"
    [searchable]="false"
    [isRatingLayout]="true"
    [multiple]="false"
  >
  </base-filter-dropdown>

  <base-filter-dropdown
    [items]="experienceOptions"
    [searchable]="false"
    bindOptionLabel="label"
    formControlName="experience"
    customAvatarIcon="fa-building"
    filterName="tooltip.experienceInCompany"
    [multiple]="false"
  >
  </base-filter-dropdown>
</form>

<div class="d-flex align-items-center flex-wrap mt-2">
  <div
    *ngFor="let filter of activeFilters"
    class="rounded-pill bg-secondary px-4 py-2 me-3 active-filter mt-3 btn-sm d-flex align-items-center"
  >
    <span class="pe-1 fw-normal">
      {{
        filter.filter === baseCustomerInquiryFilters.search
          ? ('search.nominative' | translate)
          : (labels[filter.filter] | translate)
      }}:
    </span>
    <ng-container *ngIf="filter.filter !== inquiryOffersFiltersType.rating">
      <span>
        {{
          (filter.name | translate) ||
            (filter.value.label | translate) ||
            (filter.value.name | translate) ||
            (filter.value | baseFormatDate)
        }}
      </span>
    </ng-container>
    <ng-container *ngIf="filter.filter === inquiryOffersFiltersType.rating">
      <base-rating
        [currentRate]="filter.value"
        [hideCount]="true"
        class="my-0 mx-auto"
      ></base-rating>
    </ng-container>
    <i
      class="fa-solid fa-xmark ms-2 pointer"
      (click)="removeFilter(filter)"
    ></i>
  </div>
  <div
    class="pointer mt-3"
    (click)="clearFilters()"
    *ngIf="activeFilters.length"
  >
    {{ 'filter.reset' | translate }}
  </div>
</div>
